import React from "react";
import Facebook from "src/shared/Icon/Facebook";
import Instagram from "src/shared/Icon/Instagram";
import Email from "src/shared/Icon/Email";

import classes from "./Footer.module.css";

const Footer = () => {
  return (
    <footer className={classes.footer}>
      <div className={classes.contact}>
        <p>Contact us:</p>
        <Email />
      </div>
      <div className={classes.follow}>
        <span>Follow us:</span>
        <Facebook />
        <Instagram />
      </div>
    </footer>
  );
};

export default Footer;
